/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Wyczyść wybór',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Nie można pobrać danych',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Kliknij, aby spróbować ponownie',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ładowanie...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Pokaż więcej',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nie znaleziono dopasowań',
  'paginated-picker.async-select.select.option.error-message': 'Nie można pobrać danych',
  'paginated-picker.async-select.select.option.retry-message': 'Kliknij, aby spróbować ponownie',
  'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Pokaż pełną listę'
};